<template>
  <div>
    <div v-for="terms in termsList" :key="terms.id">
      <span style="padding-left:0; display: inline-block" class="custom-control custom-checkbox ">
        <w-checkbox :model="termsIds" :value="terms.id" :title="terms.acceptText" />
      </span>

      <span style="vertical-align: top;" class="badge badge-secondary ml-2" @click.prevent="$emit('view', terms)">
        <i class="fal fa-fw fa-search" />
      </span>
    </div>
  </div>
</template>

<script>
import WCheckbox from '@witkac/bootstrap4-components/src/components/checkbox.vue';

// @vuese
// Lista regulaminów do zaakceptowania
// @group Components
export default {
  name: 'TermsList',
  components: {
    WCheckbox
  },
  props: {
    // Regulaminy do wyświetlania
    termsList: {
      type: Array,
      required: true
    },
    // Schema z id regulaminów
    termsIds: {
      type: Object,
      required: true
    }
  }
};
</script>
